import Vue from 'vue'
import App from './App.vue'
import request from '@/utils/request'

import { router } from '@/router'

import '@/styles/common.scss'
import store from './store'
import ElementUI from 'element-ui'
import VueClipBoard from 'vue-clipboard2'
import 'element-ui/lib/theme-chalk/index.css'
import './permission'
import SlideVerify from 'vue-monoplasty-slide-verify'

const DS = require('dsbridge')

Vue.use(ElementUI)

Vue.use(VueClipBoard)

Vue.use(SlideVerify)


Vue.prototype.$http = request
Vue.prototype.DS = DS
Vue.config.productionTip = false
Vue.config.devtools = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
